import type {TS} from "../../../type/ts.js";

/**
 * Returns true if the given Node is a Declaration
 * Uses an internal non-exposed Typescript helper to decide whether or not the Node is a declaration
 */
export function isDeclaration(node: TS.Node, typescript: typeof TS): node is TS.Declaration {
	return (typescript as unknown as {isDeclaration(node: TS.Node): boolean}).isDeclaration(node);
}

export function isNamedDeclaration(node: TS.Node | TS.NamedDeclaration, typescript: typeof TS): node is TS.NamedDeclaration {
	if (typescript.isPropertyAccessExpression(node)) return false;
	return "name" in node && node.name != null;
}
